import { useQuery } from '@tanstack/react-query'
import { dashboardService } from '../../services/dashboard/dashboardService'

// Query keys
export const dashboardKeys = {
  all: ['dashboard'] as const,
  stats: () => [...dashboardKeys.all, 'stats'] as const,
}

// Get dashboard statistics
export const useDashboardStats = () => {
  return useQuery({
    queryKey: dashboardKeys.stats(),
    queryFn: dashboardService.getDashboardStats,
    staleTime: 2 * 60 * 1000, // 2 minutes - dashboard data doesn't change frequently
    refetchInterval: 5 * 60 * 1000, // Auto-refetch every 5 minutes
  })
}


